import { cn } from '../lib/cn';
import { ROLE_META } from '../lib/roles';
import type { Role } from '../lib/api';

type Size = 'xs' | 'sm' | 'md';

const SIZES: Record<Size, { wrap: string; icon: string; text: string }> = {
  xs: { wrap: 'px-1.5 py-0.5 gap-1',   icon: 'h-2.5 w-2.5', text: 'text-[9px]' },
  sm: { wrap: 'px-2 py-0.5 gap-1.5',   icon: 'h-3 w-3',     text: 'text-[10px]' },
  md: { wrap: 'px-2.5 py-1 gap-1.5',   icon: 'h-3.5 w-3.5', text: 'text-xs' },
};

export function RoleBadge({
  role,
  size = 'sm',
  label,
  className,
}: {
  role: Role;
  size?: Size;
  label?: string;
  className?: string;
}) {
  const meta = ROLE_META[role];
  const Icon = meta.icon;
  const s = SIZES[size];

  return (
    <span
      className={cn(
        'inline-flex items-center rounded-md font-display font-black uppercase tracking-[0.18em]',
        meta.tone,
        meta.text,
        s.wrap,
        s.text,
        className
      )}
    >
      <Icon className={s.icon} strokeWidth={2.5} />
      {label ?? meta.label}
    </span>
  );
}
